// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container .all-pills-container {
  height: calc(100vh - 56px);
  display: flex;
  max-width: 1120px;
  flex-direction: column;
  justify-content: space-between;
}
.container .all-pills-container .back-page {
  display: flex;
  margin: 35px 0;
  cursor: pointer;
  text-decoration: none;
}
.container .all-pills-container__desktop-title {
  display: none;
}
.container .all-pills-container .all-pill-cards {
  gap: 24px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.container .all-pills-container .all-pill-cards .media-area {
  cursor: pointer;
}
.container .all-pills-container .all-pill-cards .media-area .video {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 100%;
  padding: 16px;
  max-width: 288px;
  min-height: 207px;
  border-radius: 4.91px 24.54px 24.54px 24.54px;
  background-color: #fff;
  box-shadow: 0 4px 4px 2px rgba(0, 0, 0, 0.05);
}
.container .all-pills-container .all-pill-cards .media-area .image {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 100%;
  max-width: 357px;
  min-height: 184px;
}
.container .all-pills-container__pagination {
  padding: 24px 0;
}
@media (min-width: 560px) {
  .container .wrapper-all-pills {
    padding-top: 15px;
  }
}
@media (min-width: 1024px) {
  .container .wrapper-all-pills {
    padding-left: 30px;
    padding-right: 30px;
  }
}
@media (min-width: 1280px) {
  .container .wrapper-all-pills {
    padding-left: 80px;
    padding-right: 80px;
    padding-bottom: 50px;
  }
}
@media (min-width: 768px) {
  .container .all-pills-container {
    margin-left: 0;
  }
  .container .all-pills-container .all-pill-cards {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .container .all-pills-container .all-pill-cards .media-area .video {
    min-height: 230px;
    max-width: 357px;
  }
}
@media (min-width: 1024px) {
  .container .all-pills-container__mobile {
    display: none;
  }
  .container .all-pills-container__desktop-title {
    display: block;
    margin: 0 0 35px;
  }
  .container .all-pills-container .all-pill-cards {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
  .container .all-pills-container .all-pill-cards .video,
  .container .all-pills-container .all-pill-cards .image {
    min-width: 286px;
  }
  .container .all-pills-container__pagination {
    padding: 0;
    padding-top: 16px;
    padding-bottom: 5%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/all-pills/index.scss"],"names":[],"mappings":"AACE;EACE,0BAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,8BAAA;AAAJ;AAEI;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;AAAN;AAGI;EACE,aAAA;AADN;AAII;EACE,SAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AAFN;AAIM;EACE,eAAA;AAFR;AAIQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,6CAAA;EACA,sBAAA;EACA,6CAAA;AAFV;AAKQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AAHV;AAQI;EACE,eAAA;AANN;AAUI;EADF;IAEI,iBAAA;EAPJ;AACF;AAQI;EAJF;IAMM,kBAAA;IACA,mBAAA;EANN;AACF;AAQI;EAVF;IAYM,kBAAA;IACA,mBAAA;IACA,oBAAA;EANN;AACF;AAUE;EACE;IACE,cAAA;EARJ;EAUI;IACE,aAAA;IACA,8BAAA;EARN;EAWQ;IACE,iBAAA;IACA,gBAAA;EATV;AACF;AAcE;EAEI;IACE,aAAA;EAbN;EAgBI;IACE,cAAA;IACA,gBAAA;EAdN;EAiBI;IACE,aAAA;IACA,kCAAA;EAfN;EAiBM;;IAEE,gBAAA;EAfR;EAmBI;IACE,UAAA;IACA,iBAAA;IACA,kBAAA;EAjBN;AACF","sourcesContent":[".container {\n  .all-pills-container {\n    height: calc(100vh - 56px);\n    display: flex;\n    max-width: 1120px;\n    flex-direction: column;\n    justify-content: space-between;\n\n    .back-page {\n      display: flex;\n      margin: 35px 0;\n      cursor: pointer;\n      text-decoration: none;\n    }\n\n    &__desktop-title {\n      display: none;\n    }\n\n    .all-pill-cards {\n      gap: 24px;\n      width: 100%;\n      display: flex;\n      align-items: center;\n      flex-direction: column;\n\n      .media-area {\n        cursor: pointer;\n\n        .video {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          cursor: pointer;\n          width: 100%;\n          padding: 16px;\n          max-width: 288px;\n          min-height: 207px;\n          border-radius: 4.91px 24.54px 24.54px 24.54px;\n          background-color: #fff;\n          box-shadow: 0 4px 4px 2px rgba(0, 0, 0, 0.05);\n        }\n\n        .image {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          cursor: pointer;\n          width: 100%;\n          max-width: 357px;\n          min-height: 184px;\n        }\n      }\n    }\n\n    &__pagination {\n      padding: 24px 0;\n    }\n  }\n  .wrapper-all-pills {\n    @media (min-width: 560px) {\n      padding-top: 15px;\n    }\n    @media (min-width: 1024px) {\n      padding: {\n        left: 30px;\n        right: 30px;\n      }\n    }\n    @media (min-width: 1280px) {\n      padding: {\n        left: 80px;\n        right: 80px;\n        bottom: 50px;\n      }\n    }\n  }\n\n  @media (min-width: 768px) {\n    .all-pills-container {\n      margin-left: 0;\n\n      .all-pill-cards {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n\n        .media-area {\n          .video {\n            min-height: 230px;\n            max-width: 357px;\n          }\n        }\n      }\n    }\n  }\n  @media (min-width: 1024px) {\n    .all-pills-container {\n      &__mobile {\n        display: none;\n      }\n\n      &__desktop-title {\n        display: block;\n        margin: 0 0 35px;\n      }\n\n      .all-pill-cards {\n        display: grid;\n        grid-template-columns: 1fr 1fr 1fr;\n\n        .video,\n        .image {\n          min-width: 286px;\n        }\n      }\n\n      &__pagination {\n        padding: 0;\n        padding-top: 16px;\n        padding-bottom: 5%;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
